"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeParse = void 0;
const __1 = require("..");
/**
 * Safe parses a Zod schema.
 * @export
 * @template T
 * @param {T} schema
 * @param {unknown} data
 * @param {ErrorMessageOptions} [options]
 * @return {*}  {SafeParseReturnType<T['_output']>}
 */
function safeParse(schema, data, options) {
    const result = schema.safeParse(data);
    if (!result.success) {
        const message = (0, __1.generateErrorMessage)(result.error.issues, options);
        return { success: false, error: { message } };
    }
    return {
        success: true,
        data: result.data,
    };
}
exports.safeParse = safeParse;
